export const cityLocalities = {
  Delhi: { "Mayur Vihar": 5000, "Amber Vihar": 6000, Alaknanda: 5500 },
  Mumbai: {
    "Andheri East": 7000,
    "Bandra East": 7500,
    "Bandra West": 8000,
    Bapnala: 7200,
  },
  Gurgaon: {
    "DLF Colony Old": 6000,
    "Sector 1-7": 5000,
    "Sector 104-115": 3333,
    "Sector 63-58": 4500,
    "Palam Vihar": 6600,
    "DLF Phase II": 7000,
    "License colonies": 2830,
  },
  Noida: {
    "Sector 66-150": 4300,
    "Sector 54-118": 4700,
    "Sector 104-157": 5600,
    "Sector 15A-124": 9600,
  },
  "Navi Mumbai": { Vashi: 6000, Belapur: 6200, Panvel: 5800 },
  Thane: { Kasarvadavali: 5500, "Ghodbunder Road": 5700, Majiwada: 5900 },
};

export const propertyTypes = {
  Flat: 1.2,
  Residential: 1, // Assuming Residential is not changed
  Office: 1.7,
  Shop: 1.5,
  Industrial: 2,
};

export const conversionFactors = {
  "Square feet": 1,
  "Square meter": 10.7639,
  "Square Yard": 9,
  // Marla: 272.25,
  // Hectare: 107639,
  // Acre: 43560,
  // Katha: 1361.25,
  // Bigha: 27000,
  // Biswa: 1350,
  // Gutha: 1089,
  // Ghuman: 243,
  // Kunchum: 43560,
  // Killa: 43560,
  // Andaman: 1089000,
  // Dhur: 68.06,
  // "Square Gaj": 9,
  // Kenal: 5445,
  // Cent: 435.6,
  // Gaj: 9,
  // Gajam: 9,
  // Lessa: 1008.3,
};

export const LOGO =
  "https://reecocefe1aea.b-cdn.net/wp-content/uploads/2022/09/Reecocefe-Logo.webp.bv.webp?bv_host=reecocefe.in";

export const qaData = [
  {
    question: "What is Circle Rate?",
    answer:
      "Circle rate is the minimum value set by the government for property transactions in a specific area. It serves as the benchmark for calculating stamp duty and registration charges during property sales. The circle rate is determined based on factors like location, property type, and market trends, and it may differ from the actual market value of the property.The circle rate is also known as the Reckoner rate or the guidance value",
  },
  {
    question: "Factors which Determine the Circle Rates",
    answer:
      "Circle rates are determined by various factors such as the location and type of property (residential, commercial, or industrial), property usage, and infrastructure development in the area. Proximity to key amenities like schools, hospitals, and public transport also affects the rate. The age and size of the property can further influence the circle rate. Government policies and local real estate market conditions play a crucial role as well.",
  },
  {
    question: "Is circle rate same in every city?",
    answer:
      "No, the circle rate is not the same in every city. It varies significantly from city to city and even within different localities of the same city. The circle rate, also known as the ready reckoner rate or guidance value, is set by the respective state governments or local authorities, and it reflects the minimum price at which a property can be registered in a given area.",
  },
  {
    question: "What if circle rate is more than market value?",
    answer:
      "If the circle rate is higher than the market value, buyers will pay higher stamp duty and may face additional taxes on the difference. Sellers could also be taxed on capital gains based on the higher circle rate, even if they sell at a lower market price.",
  },
  {
    question: "What is the difference between Circle rate and Market value?",
    answer:
      "The circle rate is a government-determined value used for legal and tax purposes, while market value is a more fluid, real-time estimate of a property's worth based on market conditions.",
  },
];

export const calculators = [
  {
    title: "Home Calculator",
    image: "https://www.svgrepo.com/show/195329/mortgage-insurance.svg",
    link: "/home-calculator",
  },
  {
    title: "Affordable Calculator",
    image: "https://www.svgrepo.com/show/233837/budget-cost.svg",
    link: "/affordable-plan",
  },
  {
    title: "Legal Title Check",
    image: "https://www.svgrepo.com/show/291289/contract-agreement.svg",
    link: "/emi-calculator",
  },
  {
    title: "Property Valuation Finder",
    image: "https://www.svgrepo.com/show/10038/house.svg",
    link: "/property-valuation",
  },
];

export const formVariant = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.2, duration: 0.5, ease: "easeInOut" },
  }),
};
